import { toCitySlug } from "@/lib/citySlug";

// Previously lowercased but did NOT collapse whitespace, so a display-form
// value leaking in here produced "/new delhi/events". Delegating also
// hyphenates, matching the slug shape the sitemap already emits.
const cityOrDefault = (city) => toCitySlug(city);

/** Bare contest slug — strips `{city}/contest/{slug}` paths if present */
export function extractContestBaseSlug(slugOrId) {
  const trimmed = String(slugOrId || "").trim().replace(/^\/+|\/+$/g, "");
  if (!trimmed) return "";

  const segments = trimmed.split("/");
  const contestIndex = segments.indexOf("contest");

  if (contestIndex !== -1 && segments[contestIndex + 1]) {
    return segments[contestIndex + 1];
  }

  return segments[segments.length - 1];
}

export function cityEventsUrl(city) {
  return `/${cityOrDefault(city)}/events`;
}

export function categoryUrl(city, category) {
  return `/${cityOrDefault(city)}/${category}`;
}

export function eventUrl(city, slug, category) {
  if (
    slug &&
    (slug.startsWith("event/") ||
      slug.startsWith("events/") ||
      slug.includes("/event/") ||
      slug.includes("/events/"))
  ) {
    return slug.startsWith("/") ? slug : `/${slug}`;
  }
  if (!city) {
    return category ? `/events/${slug}` : `/event/${slug}`;
  }
  return category
    ? `/${cityOrDefault(city)}/${category}/events/${slug}`
    : `/${cityOrDefault(city)}/event/${slug}`;
}

export function bookingUrl(city, slug, category) {
  if (
    slug &&
    (slug.startsWith("event/") ||
      slug.startsWith("events/") ||
      slug.includes("/event/") ||
      slug.includes("/events/"))
  ) {
    const baseSlug = slug.startsWith("/") ? slug : `/${slug}`;
    return `${baseSlug}/book`;
  }
  if (!city) {
    return category ? `/events/${slug}/book` : `/event/${slug}/book`;
  }
  return category
    ? `/${cityOrDefault(city)}/${category}/events/${slug}/book`
    : `/${cityOrDefault(city)}/event/${slug}/book`;
}

export function contestUrl(city, slug) {
  const baseSlug = extractContestBaseSlug(slug);
  if (!baseSlug) return "/";

  let citySegment = city ? cityOrDefault(city) : "";
  if (!citySegment) {
    const trimmed = String(slug || "").trim().replace(/^\/+|\/+$/g, "");
    const segments = trimmed.split("/");
    const contestIndex = segments.indexOf("contest");
    if (contestIndex > 0) {
      citySegment = segments[contestIndex - 1].toLowerCase();
    }
  }

  return `/${citySegment || cityOrDefault("Ahmedabad")}/contest/${baseSlug}`;
}

export function cityContestsUrl(city) {
  return `/${cityOrDefault(city)}/contests`;
}

export function blogUrl(slug, city) {
  const base = city ? `/${cityOrDefault(city)}/blogs` : "/blogs";
  return slug ? `${base}/${slug}` : base;
}
